'use client';
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import LearnSection from './components/LearnSection';
import PreviewSection from './components/PreviewSection';
import AudienceSection from './components/AudienceSection';
import DownloadSection from './components/DownloadSection';

export default function MasteringSWOTPage() {
  useEffect(() => {
    // Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&family=JetBrains+Mono:wght@300;400;500&display=swap';
    document.head?.appendChild(link);

    // Intersection Observer for scroll reveals
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    document
      .querySelectorAll('section, .reveal-group, .stagger-grid, .reveal-up, .reveal-blur, .reveal-text-line')?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--background)' }}>
      <Header />
      <main>
        <HeroSection />
        <OverviewSection />
        <LearnSection />
        <PreviewSection />
        <AudienceSection />
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
}